import { SET_ALERT } from "./actionTypes";

const alertAction = () => {
    return { type: SET_ALERT }
};

export { alertAction };